// @ helpers
const { formatText } = require('core/i18n').i18n;

const StringHelper = {

    /*
     * Builds a written version of a string separated by language separators.
     *
     * @example
     * Returns "1"
     * buildWrittenList(['1'])
     *
     * @example
     * Returns "1 and 2"
     * buildWrittenList(['1', '2'])
     *
     * @example
     * Returns "1, 2 and 3"
     * buildWrittenList(['1', '2', '3'])
     *
     * @param {arrayOfStrings} list The list of words
     */
    buildWrittenList(list) {
        if (!Array.isArray(list) || list.length === 0) return '';

        const listOfWordsSeparator = formatText('periodicity-listOfWordsSeparator');
        const listOfWordsFinalSeparator = formatText('periodicity-listOfWordsFinalSeparator');
        const n = list.length;

        return n === 1 ? list[0] : list.slice(0, n - 1).join(`${listOfWordsSeparator} `)
            + ` ${listOfWordsFinalSeparator} ` + list[n - 1];
    }

}

module.exports = StringHelper;
